import React from "react";
import "./WithThePeople.css";
import bgImage from "../assets/images/people.jpg";
import teamImage from "../assets/images/team.jpg";
import trainingImage from "../assets/images/training.jpg";

const WithThePeople = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="cinfa-hero"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="cinfa-hero-overlay"></div>

        <div className="cinfa-hero-content">
          <h1 className="cinfa-hero-title">
            <span className="green">Commitment to</span>
            <br />
            <span className="purple">people</span>
          </h1>
        </div>
      </section>

      {/* ================= PATIENTS ================= */}
      <section className="patients-section">
        <div className="patients-intro">
          <h2>
            <span className="green">Patients</span>, our mission
          </h2>

          <p>
            <strong>Our goal is to improve quality of life for people</strong>{" "}
            through treatments and preventive solutions.
          </p>

          <p>
            <strong>We partner with various patient organisations in Spain</strong>{" "}
            to raise the profile of their work and to support them on their projects.
          </p>
        </div>

        <div className="patients-grid">
          <div className="patient-card green-border">
            <h3>
              <span className="italic">La voz del paciente</span> initiative
            </h3>
            <p>
              <strong>Support for 100 organisations every year</strong> on projects
              aimed at improving quality of life.
            </p>
          </div>

          <div className="patient-card green-border">
            <h3>
              <span className="italic">Ellas cuentan</span> initiative
            </h3>
            <p>
              We highlight and recognise <strong>women facing disease</strong>.
            </p>
          </div>

          <div className="patient-card purple-border">
            <h3>
              <span className="italic">La mirada del paciente</span> initiative
            </h3>
            <p>
              <strong>More than 2,200 images, two books and a short film.</strong>
            </p>
          </div>

          <div className="patient-card purple-border">
            <h3>
              <span className="italic">CinfaTeaming</span> initiative
            </h3>
            <p>
              <strong>$400,000</strong> donated to social causes over 12 years.
            </p>
          </div>

          <div className="patient-card green-border">
            <h3>Support for vulnerable groups in society</h3>
            <p>We foster access to healthcare worldwide.</p>
          </div>
        </div>
      </section>

      {/* ================= TEAM ================= */}
      <section className="team-section">
        <div className="team-grid">

          {/* LEFT */}
          <div className="team-content">
            <h2 className="team-title">
              <span className="green">Cinfa</span>{" "}
              <span className="purple">team</span>
            </h2>

            <div className="team-stats-row">
              <div className="team-stat">
                <h3>
                  <span className="green">+</span>2,300
                </h3>
                <p>professionals, 88% in Spain</p>
              </div>

              <div className="team-stat">
                <h3>
                  <span className="green">+</span>90<span className="small">%</span>
                </h3>
                <p>of the jobs are permanent</p>
              </div>
            </div>

            <h2 className="team-title secondary">
              <span className="green">Equality,</span>{" "}
              <span className="purple">diversity and inclusion</span>
            </h2>

            <div className="team-stats-row">
              <div className="team-stat">
                <h3>
                  54<span className="small">%</span>
                </h3>
                <p>of the team is made up by women</p>
              </div>

              <div className="team-stat">
                <h3>
                  <span className="green">+</span>100
                </h3>
                <p>
                  people with disabilities work for Cinfa under agreements with
                  special employment centres
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE (NO FADE) */}
          <div
            className="team-image"
            style={{ backgroundImage: `url(${teamImage})` }}
          />
        </div>
      </section>
      {/* ================= TRAINING SECTION ================= */}
<section className="training-section">
  <div className="training-grid">

    {/* IMAGE */}
    <div
  className="training-image"
  style={{ backgroundImage: `url(${trainingImage})` }}
/>

    {/* CONTENT */}
    <div className="training-content">
      <h2 className="training-title">
        <span className="green">Lifelong training</span>{" "}
        <span className="purple">for healthcare professionals</span>
      </h2>

      <p>
        We work alongside healthcare professionals to organise{" "}
        <strong>lifelong training activities and scientific sessions</strong>{" "}
        in which we tackle key issues for the medical sector.
      </p>

      <p>
        These sessions offer up-to-date{" "}
        <strong>knowledge validated by the authorities</strong>, as well as{" "}
        <strong>training credits</strong> that foster professional development.
      </p>
    </div>

  </div>
</section>
{/* ================= COMMITMENTS ================= */}
<section className="commitments-section">
  <h2 className="commitments-title">
    <span className="green">Our</span>{" "}
    <span className="purple">commitments</span>
  </h2>

  <div className="commitments-list">
    <span className="commitment-pill green-border">People move us</span>
    <span className="commitment-pill purple-border">Ethics and transparency</span>
    <span className="commitment-pill green-border">Environmental commitment</span>
    <span className="commitment-pill purple-border">
      Sustainable economic development
    </span>
  </div>
</section>
    </>
  );
};

export default WithThePeople;